import React, { useEffect, useState } from "react";
import AddonsListing from "./AddonsListing";
import { OrdersCheckout } from "../../shared";
import { getQueryData, loadStorage } from "../../../util/common";
import { Loader } from "../../shared";
import { useAppNavigation } from "../../../hooks";
import { checkTamaraOrder } from "../../../util/addonsUtils";

const AddonsDisplay = ({
  type,
  offers,
  variants,
  recommendedOffers,
  others,
  addonsView,
  setAddonsView
}) => {
  const { toTrackYourProgress } = useAppNavigation();

  const hyperpayId = getQueryData("id");
  const draftVals = loadStorage("draftVals", "sessionStorage");

  const [loader, setLoader] = useState(false);
  const [cart, setCart] = useState({ offers: [], products: [], recommendedOffers: [] });
  // const [draftData, setDraftData] = useState(null);

  useEffect(() => {
    if (hyperpayId && !draftVals) return toTrackYourProgress();
    else if (hyperpayId && draftVals) return restoreValues();
    
    checkTamaraOrder();
  }, []);

  const restoreValues = () => {
    // setDraftData(draftVals);
    setCart(draftVals.cart);
    setAddonsView(2);
    setLoader(false);
  };

  const parentClass = addonsView === 1 ? "col-md-12 col-xl-8" : "";

  return (
    <>
      <Loader show={loader} />

      <div className={parentClass}>
        {addonsView === 1 && (
          <AddonsListing
            setAddonsView={setAddonsView}
            offers={offers}
            variants={variants}
            recommendedOffers={recommendedOffers}
            cart={cart}
            setCart={setCart}
            setLoader={setLoader}
          />
        )}

        {addonsView === 2 && (
          <OrdersCheckout
            module="upsell"
            setAddonsView={setAddonsView}
            values={{
              cart: cart,
              appointment: others,
              type
            }}
            // draftData={draftData}
            setCart={setCart}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(AddonsDisplay);
